import React from 'react';
import { useSelector } from 'react-redux';
import { colors } from '../../constants/colors';
import { isForeignCityCar } from '../../utils/foreignCityCar';

/**
 * Предупреждение в карточке автомобиля: машина стоит в чужом городе.
 *
 * Такая машина попадает к менеджеру только через поиск по полному VIN. Без
 * предупреждения он решит, что она его города, и удивится, почему её нет в
 * списке (24.10.2026, просьба перенести машину в Тараз). Город и дилерский
 * центр меняются тут же, в полях ниже.
 */
export default function ForeignCityNotice({ city }) {
  const userCities = useSelector((state) => state?.user?.cities);

  if (!isForeignCityCar(city?.id, userCities)) return null;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        columnGap: '10px',
        border: `1px solid ${colors.orange}`,
        borderRadius: '8px',
        padding: '10px 14px',
        marginBottom: '16px',
        backgroundColor: '#FFF6E9',
      }}
    >
      <span
        style={{
          backgroundColor: colors.orange,
          color: colors.white,
          borderRadius: '10px',
          padding: '1px 8px',
          fontSize: '11px',
          whiteSpace: 'nowrap',
        }}
      >
        другой город
      </span>
      <span style={{ color: colors.blackPearl, fontSize: '14px' }}>
        Автомобиль стоит в городе {city?.title ?? 'другого города'} — он не из ваших городов. Чтобы работать с ним,
        смените город и дилерский центр в полях ниже.
      </span>
    </div>
  );
}
